import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { updateOrderParam } from "features/hublink/core/tei-hub-link.param";
import {
  GetTeiHubLinkCompleteOrderResponse,
  GetTeiHubLinkCompleteOrderRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkCompleteOrder {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkCompleteOrder;
  message: string;
}

const initialState: InitialState = {
  status: TeiHubLinkCompleteOrder.initial,
  message: "",
};

export const teiHubLinkCompleteOrder = createAsyncThunk(
  "teiHubLinkCompleteOrder",
  async (param: updateOrderParam, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkCompleteOrderResponse =
        await GetTeiHubLinkCompleteOrderRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkCompleteOrderSlice = createSlice({
  name: "teiHubLinkCompleteOrder",
  initialState,
  reducers: {
    resetTeiHubLinkCompleteOrder: (state) => {
      state.status = TeiHubLinkCompleteOrder.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkCompleteOrder.pending, (state) => {
        state.status = TeiHubLinkCompleteOrder.inProgress;
      })
      .addCase(teiHubLinkCompleteOrder.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = TeiHubLinkCompleteOrder.success;
          state.message = message;
        }
      })
      .addCase(teiHubLinkCompleteOrder.rejected, (state, action) => {
        state.status = TeiHubLinkCompleteOrder.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectTeiHubLinkCompleteOrder = (state: RootState) =>
  state.teiHubLinkCompleteOrder;

export const { resetTeiHubLinkCompleteOrder } =
  teiHubLinkCompleteOrderSlice.actions;
export default teiHubLinkCompleteOrderSlice.reducer;
